import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, endpoints } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = checking, null = anonymous, object = logged in
  const [user, setUser] = useState(undefined);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get(endpoints.authMe);
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (username, password) => {
    const { data } = await api.post(endpoints.authLogin, { username, password });
    if (data.token) localStorage.setItem("laka_token", data.token);
    setUser({ username: data.username });
    return data;
  };

  const logout = async () => {
    try { await api.post(endpoints.authLogout); } catch { /* ignore */ }
    localStorage.removeItem("laka_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de AuthProvider");
  return ctx;
}
